import axios from 'axios';
import { endpoints } from '../_config';

class AuthService {
    /**
     * Get Meeting auth token and meeting name
     * @returns authToken, meetingName
     */
    static async getMeeingUniqData(uuid) {
        return axios
            .get(endpoints.auth.getUniqueData(uuid))
            .then((response) => response.data);
    }
}

export { AuthService };
